import { useAuth } from '../context/AuthContext';

export function useRole() {
  const { user } = useAuth();
  const isSuperAdmin = user?.role === 'super_admin';
  const isAdmin = user?.role === 'admin';
  const isMD = user?.sub_role === 'MD';
  const isSVP = user?.sub_role === 'SVP';
  const isRCM = user?.sub_role === 'RCM';
  const isManager = user?.sub_role === 'Manager';
  const isIntern = user?.sub_role === 'Intern';
  const isSupport = user?.sub_role === 'Support Member';
  const isAdminOrAbove = isSuperAdmin || isAdmin;
  const isManagerOrAbove = isAdminOrAbove || isMD || isSVP || isRCM || isManager;
  const canEdit = !isIntern && !isSupport;
  const canDelete = isAdminOrAbove;
  const canViewAllData = isAdminOrAbove || isMD;
  const canViewRegionData = isSVP || isRCM;
  return {
    user, isSuperAdmin, isAdmin, isMD, isSVP, isRCM, isManager, isIntern, isSupport,
    isAdminOrAbove, isManagerOrAbove, canEdit, canDelete, canViewAllData, canViewRegionData,
  };
}
